var Cart = new Vue( {
    el: '.bag.vue',
    data: {
        cart: { },
        processing: false,
        fetching_title: false,
        reviews: { },
        latestLineItemKey: null,
        complementaryProducts: [ ],
        productToGetMaxQuantity: null,
        fetchedComplementaryProductsLineItemKey: [ ],
        removedCartItem: null
    },
    computed: {
        utils( ) {
            return Utils ? Utils : { };
        },
        groupedCartItems( ) {
            const groups = { };
            if ( ! this.cart.items ) return groups;
            this.cart.items.forEach( item => {
                if ( item.properties && item.properties._id ) {
                    if ( ! groups[ item.properties._id ] ) {
                        groups[ item.properties._id ] = [ ];
                    }
                    groups[ item.properties._id ].push( item );
                } else {
                    if ( ! groups[ '__single__' ] ) {
                        groups[ '__single__' ] = [ ];
                    }
                    groups[ '__single__' ].push( item );
                }
            } );
            return groups;
        },
    },
    mounted( ) {
        const _this = this;
        _this.fetchCart( );
        $( '.bag.vue' ).removeClass( 'hidden' );
        $( 'header .menu.icons .bag' ).on( 'click', function( ) {
            if ( clickDisabled ) {
                return;
            }
            $( 'section.bag' ).addClass( 'delay' );
            setTimeout( function( ) {
                $( 'section.bag' ).addClass( 'active' );
            }, 100 );
            clickDisabled = true;
            setTimeout( function( ) {
                clickDisabled = false;
            }, 750 );
        } );
        $( document ).on( 'click', '.add-to-bag, #add-to-bag, .add-to-bag-bundle', function( e ) {
            e.preventDefault( );                  
            if ( _this.processing === true ) {
                return;
            } 
            const $this = $( this );
            if ( $(this).attr( 'id' ) == 'add-to-bag' ) {
                const $required = $(this).closest( '.form' ).find( '.select.alt.required' );
                if ( $required.length ) {
                    if ( $required.find( '.text' ).text().includes( 'Select ' ) ) {
                        $required.addClass( 'error' );
                        $( 'html, body' ).animate({ scrollTop: $(this).closest( '.form' ).offset().top }, 600);
                        return;
                    }
                }
            }
            const $buttonText = $( '.text', this );                  
            const originalBtnLabel = $buttonText.text( ).trim( );
            let product_id  = $( this ).data( 'product_id' );
            let quantity    = parseInt( $( this ).data( 'quantity' ) );
            let queryString = $( 'form[action*="/cart/add"]' ).serialize( );
            let queryParams = new URLSearchParams( queryString );
            if ( ! product_id ) {
                product_id = queryParams.get( 'id' );
            }
            if ( ! quantity ) {
                quantity = parseInt( queryParams.get( 'quantity' ) );
            }
            if ( _this.cart.items.length ) {                 
                let cartIndex = _this.cart.items.findIndex( item => item.id == product_id );
                $buttonText.text( 'Processing' );
                if ( cartIndex > -1 ) {           
                    quantity += parseInt( _this.cart.items[ cartIndex ].quantity );
                    _this.updateLineItem( cartIndex, quantity ).then( ( ) => {
                        $buttonText.text( originalBtnLabel );
                    } );
                    return false;
                }
            }
            let formData = {
                'items': [ {
                    'id': product_id,
                    'quantity': quantity
                } ]                        
            };
            if ( $this.data( 'selling_plan_ids' ) ) {
                formData.items[ 0 ].selling_plan = JSON.parse( $this.data( 'selling_plan_ids' ) )[ 0 ];
            }
            $this.attr( 'disabled', true );
            _this.processing = true;
            fetch( '/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( formData )
            } )
            .then( response => response.json( ) )
            .then( response => {
                if ( 'items' in response && response.items.length > 0 ) {
                    _this.fetchCart( ).then( ( ) => {
                        $( '.bag.main' ).addClass( 'delay' );
                        setTimeout( function( ) {
                            $( '.bag.main' ).addClass( 'active' );
                            _this.scrollToTopBag( );
                        }, 100 );
                    } );
                } else {
                    if ( response.message.includes( ' added to your cart due to availability' ) ) {                                    
                        _this.getMaxAllowedQuantity( product_id );
                    } else {
                        $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( response.message.includes( 'Cart Error' ) ? 'Something went wrong.' : response.message );
                        setTimeout( function( ) {
                            $( '.message .modal' ).addClass( 'active' );
                        }, 100 );
                    }
                }
            } )
            .catch( error => {
                if ( error.message.includes( ' added to your cart due to availability' ) ) {
                    _this.getMaxAllowedQuantity( product_id );
                } else {
                    console.error( 'Error:', error );
                    $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( 'Something went wrong.' );
                    setTimeout( function( ) {
                        $( '.message .modal' ).addClass( 'active' );
                    }, 100 );
                }
            } )
            .finally( ( ) => {
                $this.removeAttr( 'disabled' );
                _this.processing = false;
                $buttonText.text( originalBtnLabel );
            } );
        } );
        const bagSection = document.querySelector( 'section.bag' );
        if ( bagSection ) {
            const observer = new MutationObserver( ( ) => {
                if ( bagSection.classList.contains( 'active' ) ) {
                    document.body.classList.add( 'active' );
                } else {
                    document.body.classList.remove( 'active' );
                }
            } );
            observer.observe( bagSection, {
                attributes: true,
                attributeFilter: [ 'class' ]
            } );
            this._bagObserver = observer;
        }
    },
    methods: {
        bulkAddToBag( $event, bundleIndex ) {
            $event.preventDefault( );
            if ( this.processing === true ) {
                return;
            }
            const _this = this;
            const $this = $( $event.currentTarget );
            const $buttonText = $this.find( '.text' );                  
            let items = [ ];
            $buttonText.text( 'Processing' );
            const bundle = Product.bundles[ bundleIndex ];
            const product_ids = Product.getProductIds( bundle );
            // Add a unique _id to all items in this bundle
            const _id = 'bundle_' + Date.now( ) + '_' + Math.floor( Math.random( ) * 10000 );
            product_ids.split( ',' ).forEach( ( product_id ) => {
                items.push( {
                    'id': product_id,
                    'quantity': 1,
                    properties: {
                        _bundle: true,
                        _id: _id
                    }
                } );
            } );
            let formData = {
                'items': items                      
            };
            $this.attr( 'disabled', true );
            _this.processing = true;
            fetch( '/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( formData )
            } )
            .then( response => response.json( ) )
            .then( response => {
                if ( 'items' in response && response.items.length > 0 ) {
                    _this.fetchCart( ).then( ( ) => {
                        $( '.bag.main' ).addClass( 'delay' );
                        setTimeout( function( ) {
                            $( '.bag.main' ).addClass( 'active' );
                            _this.scrollToTopBag( );
                        }, 100 );
                    } );
                } else {
                    $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( response.message.includes( 'Cart Error' ) ? 'Something went wrong.' : response.message );
                    setTimeout( function( ) {
                        $( '.message .modal' ).addClass( 'active' );
                    }, 100 );
                }
            } )
            .catch( error => {
                if ( error.message.includes( ' added to your cart due to availability' ) ) {
                    _this.getMaxAllowedQuantity( product_id );
                } else {
                    console.error( 'Error:', error );
                    $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( 'Something went wrong.' );
                    setTimeout( function( ) {
                        $( '.message .modal' ).addClass( 'active' );
                    }, 100 );
                }
            } )
            .finally( ( ) => {
                $this.removeAttr( 'disabled' );
                _this.processing = false;
                $buttonText.text( 'Add Bundle To Bag' );
            } );
        },
        scrollToTopBag( ) {
            $( '.bag .content .products' ).stop( ).animate( { scrollTop: 0 }, 1250 );
        },
        removeDuplicates( arr, key ) {
            const uniqueObjects = new Map( );            
            arr.forEach( item => {
                uniqueObjects.set( item[ key ], item );
            } );        
            return Array.from( uniqueObjects.values( ) );
        },
        getMaxAllowedQuantity( product_id ) {
            this.$set( this, 'productToGetMaxQuantity', product_id );
            this.fetchCart( );
        },
        fetchCart( ) {
            const _this = this;
            return fetch( '/cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            } )
            .then( response => response.json( ) )
            .then( ( response ) => {
                _this.$set( _this, 'cart', response );
                $( 'header .menu.icons .bag .quantity' ).text( response.item_count );
                let ids = [ ];
                _this.cart.items.forEach( ( item, i ) => {
                    ids.push( item.product_id );
                } );
                ids = ids.map( function ( item ) {
                    return 'id:' + item;
                } ).join( ' OR ' );
                _this.fetching_title = true;
                fetch( '/search?view=products-bag&q=' + ids + '&type=product' )
                    .then( response => response.json( ) )
                    .then( ( data ) => {
                        data.searchResults.forEach( ( product, i ) => {
                            let index = _this.cart.items.findIndex( item => item.product_id == product.id );
                            var title_tags = product.tags.filter( tag => tag.includes( 'Title_' ) );
                            if ( title_tags.length ) {
                                product.title = title_tags[ 0 ].replace( 'Title_', '' );
                                _this.$set( _this.cart.items[ index ], 'product_title', product.title );
                            }
                            _this.$set( _this.cart.items[ index ], 'complementary', product.complementary );
                            _this.getComplementaryProducts( _this.cart.items[ index ].key );
                        } );
                        if ( _this.productToGetMaxQuantity ) {
                            let items = _this.cart.items.filter( item => item.id == _this.productToGetMaxQuantity );
                            if ( ! items.length ) {
                                return;
                            }
                            let max_qty = 0;
                            let product_title = items[ 0 ].product_title;
                            items.forEach( item => {
                                max_qty += item.quantity;
                            } );
                            if ( ! $( '.bag' ).hasClass( 'active' ) ) {
                                $( '.bag.main' ).addClass( 'delay' );
                                setTimeout( function( ) {
                                    $( '.bag.main' ).addClass( 'active' );
                                }, 100 );
                            }
                            let message = `Unfortunately, we only have ${ max_qty } <strong>${ product_title }</strong> in stock. As a result, we have added ${ max_qty } to your bag.`;
                            $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).html( message );
                            setTimeout( function( ) {
                                $( '.message .modal' ).addClass( 'active' );
                            }, 100 );
                            _this.$set( this, 'productToGetMaxQuantity', null );
                        }  
                        if ( _this.removedCartItem ) {
                            if ( _this.removedCartItem.complementary && _this.removedCartItem.complementary.length ) {
                                _this.removedCartItem.complementary.forEach( ( item, i ) => {
                                    let index = _this.complementaryProducts.findIndex( _item => _item.id == item.id );
                                    if ( index > -1 ) {
                                        let proceed = true;
                                        _this.cart.items.forEach( ( cart_item, i ) => {
                                            if ( cart_item.complementary && cart_item.complementary.length ) {
                                                if ( cart_item.complementary.findIndex( _item => _item.id == item.id ) > -1 ) {
                                                    proceed = false;
                                                    return false;
                                                }
                                            }
                                        } );
                                        if ( proceed ) {
                                            _this.complementaryProducts.splice( index, 1 );
                                        }
                                    }
                                } );
                                if ( _this.fetchedComplementaryProductsLineItemKey.includes( _this.removedCartItem.key ) ) {
                                    _this.fetchedComplementaryProductsLineItemKey.splice( _this.fetchedComplementaryProductsLineItemKey.indexOf( _this.removedCartItem.key ), 1 );
                                }
                            }
                            _this.$set( _this, 'removedCartItem', null );
                        }                                       
                        _this.fetching_title = false;
                    } );
            } )
            .catch( error => console.error( 'Error:', error ) );
        },
        getComplementaryProducts( line_item_key ) {
            if ( this.fetchedComplementaryProductsLineItemKey.includes( line_item_key ) ) {
                return false;
            }
            this.fetchedComplementaryProductsLineItemKey.push( line_item_key );
            const _this = this;
            const line_item = this.cart.items.find( item => item.key == line_item_key );
            if ( this.cart.items.findIndex( item => item.id == line_item.id ) > -1 ) {
                let index = _this.complementaryProducts.findIndex( _item => _item.id == line_item.id );
                if ( index > -1 ) {
                    _this.complementaryProducts.splice( index, 1 );
                }
            }
            if ( line_item.complementary.length == 0 ) {
                return;
            }
            let ids = [ ];
            let complementaryProducts = [ ];
            line_item.complementary.forEach( ( item, i ) => {
                if ( complementaryProducts.findIndex( _item => _item.id == item.id ) == -1 && _this.complementaryProducts.findIndex( _item => _item.id == item.id ) == -1 && _this.cart.items.findIndex( _item => _item.id == item.id ) == -1 ) {
                    ids.push( item.product_id );
                    complementaryProducts.push( item );
                }
            } );
            ids = ids.map( function ( item ) {
                return 'id:' + item;
            } ).join( ' OR ' );
            let url = '/search?view=products&q=' + ids + '&type=product';
            fetch( url )
            .then( response => response.json( ) )
            .then( ( products ) => {
                products.forEach( item => {
                    let i = complementaryProducts.findIndex( _item => _item.product_id == item.id );
                    complementaryProducts[ i ] = { ...item, ...complementaryProducts[ i ] };
                } );
                complementaryProducts = _this.removeDuplicates( complementaryProducts.concat( _this.complementaryProducts ), 'id' );
                _this.$set( _this, 'complementaryProducts', complementaryProducts );
                setTimeout( ( ) => {
                    $( '.bag .complementary' ).removeClass( 'hidden' );
                }, 1 );
                let ids = [ ];
                products.forEach( item => {
                    if ( ! ( item.type in _this.reviews ) && ! ids.includes( item.type ) ) {
                        ids.push( item.type );
                    }
                } );
                let url = `https://alt.hemway.com/api/index.php/review/summary?productId=${ ids.toString( ) }`;                    
                const payload = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
                fetch( url, payload )
                .then( response => response.json( ) )
                .then( data => {
                    for ( const key in data ) {
                        _this.$set( _this.reviews, key, data[ key ] );
                    }
                } )
                .catch( error => {
                    console.error( 'Error:', error );
                    return [ ];
                } );
            } );
        },
        formatMoney( value ) {
            let num = parseFloat( value ) / 100;
            return window.theme.currencySymbol + this.utils.numberWithCommas( num.toFixed( 2 ) );
        },
        updateQuantity( index, operation ) {
            const line_item = this.cart.items[ index ];
            let quantity = operation == 'minus' ? line_item.quantity - 1 : line_item.quantity + 1;
            this.$set( this.cart.items[ index ], 'quantity', quantity );
            this.updateLineItem( index, quantity );
        },
        updateLineItem( index, quantity ) {
            if ( this.processing === true ) {
                return;
            }
            const _this = this;
            const line_item = this.cart.items[ index ];
            this.processing = true;
            let formData = {
                'id': line_item.key,
                'quantity': quantity
            };
            return fetch( '/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( formData )
            } )
            .then( response => {
                return response.json( );
            } ).then( response => {
                if ( 'message' in response && response.message.includes( ' added to your cart due to availability' ) ) { 
                    _this.processing = false;
                    _this.getMaxAllowedQuantity( line_item.id );
                } else if ( 'items' in response && response.items.length > 0 ) {
                    _this.latestLineItemKey = response.items[ 0 ].key;
                    _this.fetchCart( )
                    .then( ( ) => {
                        _this.processing = false;
                        if ( ! $( '.bag.main' ).hasClass( 'active' ) ) {
                            $( '.bag.main' ).addClass( 'delay' );
                            setTimeout( function( ) {
                                $( '.bag.main' ).addClass( 'active' );
                                _this.scrollToTopBag( );
                            }, 100 );
                        }
                    } );
                } else {
                    $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( 'Something went wrong.' );
                    setTimeout( function( ) {
                        $( '.message .modal' ).addClass( 'active' );
                    }, 100 );
                }
            } )
            .catch( ( error ) => {
                console.error( 'Error:', error );
                $( '.message .modal' ).addClass( 'delay' ).find( 'p' ).text( 'Something went wrong.' );
                setTimeout( function( ) {
                    $( '.message .modal' ).addClass( 'active' );
                }, 100 );
            } );
        },
        removeLineItem( key ) {
            if ( this.processing ) {
                return;
            }
            const line_item = this.cart.items.find( item => item.key == key );
            if ( ! line_item ) {
                return;
            }
            const _this = this;
            this.processing = true;
            let formData = {
                'id': key,
                'quantity': 0
            };
            fetch( '/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( formData )
            } )
            .then( response => {
                return response.json( );
            } ).then( response => {
                _this.fetchCart( )
                    .finally( ( ) => {
                        _this.processing = false;
                        _this.$set( _this, 'removedCartItem', line_item );
                    } );
            } )
            .catch( ( error ) => {
                console.error( 'Error:', error );
            } );
        },
        parseLabel( label, line_item ) {
            if ( label.includes( 'Glitter Colour' ) ) {
                return line_item.product_title.includes( 'Shaped' ) ? 'Colour' : 'Glitter';
            }          
            if ( label.includes( 'Sealant Colour' ) ) {
                return 'Colour';
            }          
            if ( label.includes( 'Grout Colour' ) ) {
                return 'Grout';
            }
            if ( 'Size' == label && line_item.product_type == 'A5 Peel & Stick Sample' ) {
                return 'Paint';
            }          
            return label;
        },
        closeBag( ) {
            $( 'section.bag' ).removeClass( 'active' );
            setTimeout( function( ) {
                $( 'section.bag' ).removeClass( 'delay' );
                clickDisabled = false;
            }, 750 );         
        }
    }
} );
